import { doMutation } from "../../core-module/util/graphqlHelper";

export const sendOtp = ({ countryCode, phoneOrEmail }) => {
  const mutation = require("../api/mutation/sendOtp.gql");
  const variables = { countryCode, phoneOrEmail };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) return { data: data.sendOtp };
    else if (error) return { error: JSON.stringify(error) };
  });
};

export const forgotPassword = forgotPasswordInput => {
  const mutation = require("../api/mutation/forgotPassword.gql");
  const variables = { input: forgotPasswordInput };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) return { data: data.forgotPassword };
    else if (error) return { error: JSON.stringify(error) };
  });
};
